export const countriesWithStates = ['australia'];

export const countriesWithoutStates = [];
